/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Logo from 'images/logo.gif';
import { Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import GoogleButton from 'react-google-button';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import { LOGIN_URL, PROJECT_WEBSITE_URL } from '../config';

const styles = theme => ({
  Login: {
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: '5vh',
  },
  Logo: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    textAlign: 'center',
    height: '100px',
    objectFit: 'contain',
  },
  GoogleButton: {
    margin: '15px auto',
  },
  Content: {
    padding: '20px',
  },
  gdpr: {
    fontWeight: 700,
  },
  link: {
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
});

export class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      termsAgreed: false,
      ToSOpen: false,
    };

    this.openToS = this.openToS.bind(this);
    this.closeToS = this.closeToS.bind(this);
    this.closeToSAndAgree = this.closeToSAndAgree.bind(this);
  }

  openToS() {
    this.setState({ ToSOpen: true });
  }

  closeToS() {
    this.setState({ ToSOpen: false });
  }

  closeToSAndAgree() {
    this.setState({ ToSOpen: false, termsAgreed: true });
  }

  render() {
    const { classes } = this.props;
    const { termsAgreed, ToSOpen } = this.state;

    return (
      <React.Fragment>
        <Paper className={classes.Login}>
          <img src={Logo} alt="Myanmar Timber Elephant Project" className={classes.Logo} />
          <div className={classes.Content}>
            <Typography>
              {'Welcome to Myanmar Timber Elephant Project!'}
            </Typography>
            <Typography>
              {'Please login using your Google account.'}
            </Typography>
            <GoogleButton
              disabled={!termsAgreed}
              className={classes.GoogleButton}
              onClick={() => {
                window.location = `${LOGIN_URL}`;
              }}
            />
            <Typography className={classes.gdpr} gutterBottom>
              <Checkbox
                checked={termsAgreed}
                onChange={() => this.setState({ termsAgreed: !termsAgreed })}
              />
              {'I agree to the '}
              <span className={classes.link} onClick={this.openToS}>
                {'terms of service and privacy policy.'}
              </span>
            </Typography>
            <Typography>
              {'Learn more about the project at our website:'}
            </Typography>
            <a href={PROJECT_WEBSITE_URL}>
              {PROJECT_WEBSITE_URL}
            </a>
          </div>
        </Paper>
        <Dialog
          open={ToSOpen}
          onClose={this.closeToS}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            {'Privacy Policy'}
          </DialogTitle>
          <DialogContent>
            <PrivacyPolicy />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeToSAndAgree} variant="contained" autoFocus>
              {'Agree'}
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.shape().isRequired,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/login/Login.jsx